import { render, staticRenderFns } from "./CreateRoyalTower.vue?vue&type=template&id=790330f1&"
import script from "./CreateRoyalTower.vue?vue&type=script&lang=js&"
export * from "./CreateRoyalTower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports